import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FusService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  private headerFile(accessToken: string) {
    let headers = new HttpHeaders({
      //"Content-Type": "multipart/form-data",
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken,
    });
    headers.append("enctype", "multipart/form-data");
    return headers;
  }

  getFusById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusById/' + id, { headers: this.header(this.token) });
  }

  getFusParaPagoById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'getFusParaPagoById/' + id, { headers: this.header(this.token) });
  }

  getPatidasByTareaId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'patidasByTareaId/' + id, { headers: this.header(this.token) });

  }

  getPatidasByTareaIdFUS(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'patidasByTareaIdFUS/' + id, { headers: this.header(this.token) });
  }

  postFus(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'fus', bodyString, { headers: this.header(this.token) });
  }

  updateFus(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'fus', bodyString, { headers: this.header(this.token) });
  }

  getListFusByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusAllByTechoId/' + id, { headers: this.header(this.token) });
  }
  
  getListFusAprobadoCByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusAprobadoContabilidadByTechoId/' + id, { headers: this.header(this.token) });
  }  

  getListFusByEstadoId(id: number, tipo_agregacion_id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'fusAllByEstadoId/' + id + '/' + tipo_agregacion_id, { headers: this.header(this.token) });
  } 

  getListFusPagadosByIdFUS(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listFusPagadosByIdFUS/' + id, { headers: this.header(this.token) });
  }

  getListaFusArevertir(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listaFusArevertir/' + id, { headers: this.header(this.token) });
  }
  
  getFusAllByEstadoNroFUS(nroFus: string): Observable<any> {
    return this.http.get(this.baseUrl + 'FusAllByEstadoNroFUS/' + nroFus, { headers: this.header(this.token) });
  }

  getFusAllByEstadoNroFUSC31(nroFus: string): Observable<any> {    
    return this.http.get(this.baseUrl + 'FusAllByEstadoNroFUSC31/' + nroFus, { headers: this.header(this.token) });
  }

  getListPptoSegFus(): Observable<any> {
    return this.http.get(this.baseUrl + 'fusUsuariosPresupuesto', { headers: this.header(this.token) });
  }

  getFusAdmById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusAdmById/' + id, { headers: this.header(this.token) });
  }

  postSetEstadoFusAdm(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'fusSeguimiento', bodyString, { headers: this.header(this.token) });
  }

  updateFusEstadoRevision(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaFusEnviarARevision', bodyString, { headers: this.header(this.token) });
  }

  getSeguimientoByFusId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'poaFusSeguimientoById/' + id, { headers: this.header(this.token) });
  }

  getFusModificacionesByFusId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusModificacionesByFusId/' + id, { headers: this.header(this.token) });
  }

  postFusModificacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'fusModificacion', bodyString, { headers: this.header(this.token) });
  }

  deleteModificacionPartida(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'fusModificacion/' + id, { headers: this.header(this.token) });
  }

  getFusEstadosByUsuario(): Observable<any> {
    return this.http.get(this.baseUrl + 'fusEstadosByUsuario', { headers: this.header(this.token) });
  }

  putFusActualizaJefatura(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'fusActualizaJefatura', bodyString, { headers: this.header(this.token) });
  }

  postFusApruebaPtto(data: any, file: any): Observable<any> {
    const fd: FormData = new FormData();
    fd.append('file', file);
    fd.append('id', data.id);
    fd.append('nro_c31', data.nroC31);
    fd.append('monto_c31', data.montoC31);
    fd.append('fecha_c31', data.fechaC31);
    fd.append('observacion', data.observacion);
    fd.append('fuses', data.fuses);
    return this.http.post(this.baseUrl + 'fusApruebaPtto', fd, { headers: this.headerFile(this.token) });
  }

  putFusObservaPtto(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'fusObservaPtto', bodyString, { headers: this.header(this.token) });
  }

  deleteFus(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'fus/' + id, { headers: this.header(this.token) });
  }

  getListUeSegFus(): Observable<any> {
    return this.http.get(this.baseUrl + 'fusUsuariosSeguimiento', { headers: this.header(this.token) });
  }

  getFusPorAprobar(i_id: number, e_id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'fusPorAprobarContabilidad/' + i_id + '/' + e_id, { headers: this.header(this.token) });
  }

  postPagarFus(data: any): Observable<any> {    
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'pagarFUS', bodyString, { headers: this.header(this.token) });
  }

  savePago(data: any): Observable<any> {    
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'savePago', bodyString, { headers: this.header(this.token) });
  }

  pagoById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'pagoById/' + id, { headers: this.header(this.token) });
  }

  deletePago(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deletePago/' + id, { headers: this.header(this.token) });
  }

  saveFinalizarPago(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'saveFinalizarPagoRevertir', bodyString, { headers: this.header(this.token) });
  }
  
  getObjetoContratacion(): Observable<any> {
    return this.http.get(this.baseUrl + 'objetoContratacion', { headers: this.header(this.token) });
  }

  getObjetoContratacionTipo(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'objetoContratacionTipo/' + id, { headers: this.header(this.token) });
  }

  getListaPacByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listaPacByTechoId/' + id, { headers: this.header(this.token) });
  }

}
